import React from 'react';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import StyledAppbarButtonLink from 'common/theme/appbar/StyledAppbarButtonLink';

function AppBarButtonLink({ label, path, target = '_self' }) {
  return (
    <StyledAppbarButtonLink
      component={RouterLink}
      to={path}
      size="small"
      target={target}
      variant="contained">
      <span>{label}</span>
    </StyledAppbarButtonLink>
  );
}

AppBarButtonLink.propTypes = {
  label: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  target: PropTypes.oneOf(['_self', '_blank'])
};

export default AppBarButtonLink;

